import React, { FunctionComponent, useState } from 'react';
import styles from './accordion-item.module.scss';
import Section from '../../section/section';
import Arrow from '../../../assets/images/slide-left.inline.svg';

export interface IAccordionItemProps {
  header: string;
  children: IKontentItem[];
}

export const AccordionItem: FunctionComponent<IAccordionItemProps> = ({
  header,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleItem = (event: React.MouseEvent<HTMLElement>): void => {
    setIsOpen(prevState => !prevState);
  };

  return (
    <div className={`${styles.wrapper} ${isOpen && styles.wrapperIsOpen}`}>
      <div className={styles.headerWrapper} onClick={toggleItem}>
        <h2 className={styles.header}>{header}</h2>
        <Arrow className={styles.headerIcon} />
      </div>
      <div className={styles.itemsWrapper}>
        {children &&
          children.map((item: IKontentItem, i) => (
            <Section linkedItem={item} key={i} />
          ))}
      </div>
    </div>
  );
};
